import { useEffect, useState } from 'react';

const useStableScrollTrigger = (options: { threshold?: number, disableHysteresis?: boolean }) => {
    const { threshold = 100, disableHysteresis = false } = options;
    const [isTriggered, setIsTriggered] = useState(false);

    useEffect(() => {
        let ticking = false;
        let lastScrollY = 0;

        const handleScroll = () => {
            if (!ticking) {
                requestAnimationFrame(() => {
                    const currentScrollY = window.scrollY;
                    let shouldTrigger;

                    if (disableHysteresis) {
                        shouldTrigger = currentScrollY > threshold;
                    } else {
                       const triggerThreshold = currentScrollY > lastScrollY ? threshold : threshold * 0.8;
                       shouldTrigger = currentScrollY > triggerThreshold;
                    }
                    // not so trigger happy now huh?
                    setIsTriggered((prev) => (prev !== shouldTrigger ? shouldTrigger : prev));

                    lastScrollY = currentScrollY;
                    ticking = false;
                });
                ticking = true;
            }
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, [threshold, disableHysteresis]);

    return isTriggered;
};

export default useStableScrollTrigger;
